import { Controller } from "@hotwired/stimulus"

// Adapts the project form to the pricing type: rate label and the billing day field.
export default class extends Controller {
  static targets = ["pricingType", "rateLabel", "billingDay", "retainerOnly"]
  static values = { rateLabels: Object }

  connect() {
    this.update()
  }

  update() {
    const type = this.pricingTypeTarget.value
    this.rateLabelTarget.textContent = this.rateLabelsValue[type]
    this.retainerOnlyTargets.forEach((field) => { field.hidden = type !== "retainer" })
  }
}
